// Type de connexion courant : natif (Capacitor Network) wifi | cellular | none | unknown ; web : navigator.connection.
import { Capacitor } from "@capacitor/core";

let _type = "unknown";
let _connected = true;
if (Capacitor.isNativePlatform()) {
  import("@capacitor/network").then(({ Network }) => {
    Network.getStatus().then((s) => { _type = s.connectionType; _connected = s.connected !== false; }).catch(() => {});
    Network.addListener("networkStatusChange", (s) => {
      const was = _connected;
      _type = s.connectionType; _connected = s.connected !== false;
      // Retour du réseau (données / Wi-Fi) → l'écran « Reconnexion » et la config réessaient tout de suite.
      if (_connected && !was) { try { window.dispatchEvent(new Event("yalola:network-online")); } catch { /* noop */ } }
    });
  }).catch(() => {});
}

// Hors ligne d'après l'appareil (natif : Capacitor Network ; web : navigator.onLine).
export const isOffline = () => (Capacitor.isNativePlatform() ? !_connected : (typeof navigator !== "undefined" && navigator.onLine === false));

export const connectionType = () => {
  if (Capacitor.isNativePlatform()) return _type;
  const t = typeof navigator !== "undefined" ? navigator.connection?.type : "";
  return t || "unknown";
};
export const onCellular = () => connectionType() === "cellular";
// Économiseur de données du téléphone (Android : Chrome/WebView l'exposent).
export const phoneSaveData = () => !!(typeof navigator !== "undefined" && navigator.connection?.saveData);
